import { SET_DEVICE_SCREEN_SIZE, PUSH_ROUTES, PUSH_USER_ROUTES } from './types'

const configState = {
    window_size: 0,
    routes: [],
    role_routes: []
}

const getSelectedComponents = routes => {
  const pages = routes.map(item => item.page)
  return pages
}

const configReducer = (state, actions) => {
    const { type, payload } = actions

    switch (type) {
        case SET_DEVICE_SCREEN_SIZE:
          return {
              ...state,
              window_size: payload,
          }
        case PUSH_ROUTES: {
          return {
            ...state,
            routes: payload
          }
        }
        case PUSH_USER_ROUTES: {
          return {
            ...state,
            role_pages: getSelectedComponents(payload.role.routes)
          }
        }
        default: {
          return state
        }
    }

}

export { configReducer as default, configState }